import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// routes
import { CURD_USER_GROUPS_CHR } from "../../../utils/routes";

// ---------------------------------------------------------------------

export const createUserGroupsChr = createAsyncThunk(
  "userGroupsChr/createUserGroupsChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_USER_GROUPS_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getUserGroupsChr = createAsyncThunk(
  "userGroupsChr/getUserGroupsChr",
  async (obj, { rejectWithValue }) => {
    try {
      const response = await axios.get(CURD_USER_GROUPS_CHR, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response);
    }
  }
);

export const updateUserGroupsChr = createAsyncThunk(
  "userGroupsChr/updateUserGroupsChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_USER_GROUPS_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteUserGroupsChr = createAsyncThunk(
  "userGroupsChr/deleteUserGroupsChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_USER_GROUPS_CHR, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const userGroupsChrSlice = createSlice({
  name: "userGroupsChr",
  initialState: {
    loading: false,
    message: "",
    errMessage: "",
    userGroupsData: [],
    selectedData: {},
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    rowSelect: (state, action) => {
      state.selectedData = action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    [createUserGroupsChr.pending]: (state, action) => {
      state.loading = true;
    },
    [createUserGroupsChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createUserGroupsChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getUserGroupsChr.pending]: (state, action) => {
      state.loading = true;
    },
    [getUserGroupsChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.userGroupsData = action?.payload?.data;
    },
    [getUserGroupsChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateUserGroupsChr.pending]: (state, action) => {
      state.loading = true;
    },
    [updateUserGroupsChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateUserGroupsChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteUserGroupsChr.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteUserGroupsChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteUserGroupsChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
  },
});

export const { resetMessage, resetErrMessage, rowSelect } =
  userGroupsChrSlice.actions;
export default userGroupsChrSlice.reducer;
